import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../mock";

export default function HairPreview() {
  return (
    <section className="bg-cream py-28">
      <div className="max-w-[1300px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="grid grid-cols-2 gap-4 reveal">
          <div className="img-zoom rounded-sm overflow-hidden aspect-[3/4] mt-10">
            <img src={IMAGES.hairGlossy} alt="Healthy hair" className="w-full h-full object-cover" />
          </div>
          <div className="img-zoom rounded-sm overflow-hidden aspect-[3/4]">
            <img src={IMAGES.hairTransplant} alt="Hair restoration" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="eyebrow text-gold">The Hair Clinic</span>
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-light text-ink leading-tight">
            Medical &amp; surgical <span className="italic text-gold">hair restoration</span>
          </h2>
          <p className="font-sans text-muted-ink text-[15px] leading-[1.9] mt-7">
            Hair thinning affects both men and women — and it is often medical in nature. Our physician-led Hair Clinic offers research-proven treatments: hair loss programs, Mesotherapy, PRP and surgical transplants, each tailored to you.
          </p>
          <Link to="/hair-clinic" className="inline-flex items-center gap-2 btn-outline-dark mt-9">
            Explore The Hair Clinic <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
